import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL ||
  "https://porfolio-backend-production-aab2.up.railway.app/api";

export default function StudentLogin() {
  const [form, setForm] = useState({ email: "", certificateId: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/students/login`, {
        email: form.email.trim(),
        certificateId: form.certificateId.trim().toUpperCase(),
      });
      localStorage.setItem("studentToken", res.data.token);
      localStorage.setItem("studentData", JSON.stringify(res.data.student));
      navigate("/student/portal");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Check your details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", padding: 24,
      background: "radial-gradient(ellipse 60% 50% at 50% 0%, rgba(0,198,255,0.08) 0%, transparent 70%)",
    }}>
      <div style={{ width: "100%", maxWidth: 420 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <span style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 28, color: "#fff" }}>
            Ariyom<span style={{ color: "var(--accent)" }}>Tech</span>
          </span>
          <p style={{ color: "#555", marginTop: 8, fontSize: 14 }}>Student Portal Login</p>
        </div>

        <div className="card">
          <h2 style={{ fontWeight: 700, marginBottom: 8, fontSize: 20 }}>🎓 Student Login</h2>
          <p style={{ color: "#555", fontSize: 13, marginBottom: 24 }}>
            Use the email you registered with and your Certificate ID.
          </p>

          {error && (
            <div style={{
              background: "rgba(255,71,87,0.1)", border: "1px solid rgba(255,71,87,0.3)",
              borderRadius: 8, padding: "10px 14px", marginBottom: 20,
              color: "#ff4757", fontSize: 14,
            }}>{error}</div>
          )}

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div>
              <label style={{ fontSize: 13, color: "#888", display: "block", marginBottom: 6 }}>
                Registered Email
              </label>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="rahul@email.com"
                required
                autoFocus
              />
            </div>
            <div>
              <label style={{ fontSize: 13, color: "#888", display: "block", marginBottom: 6 }}>
                Certificate ID
              </label>
              <input
                type="text"
                value={form.certificateId}
                onChange={(e) => setForm({ ...form, certificateId: e.target.value.toUpperCase() })}
                placeholder="ATS-FSD-2026-001"
                required
                style={{ fontFamily: "monospace", letterSpacing: "1.5px" }}
              />
              <p style={{ fontSize: 11, color: "#444", marginTop: 6 }}>
                Your Certificate ID was shared with you after registration.
              </p>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              style={{ padding: "12px", fontSize: 15, justifyContent: "center", marginTop: 8, opacity: loading ? 0.7 : 1 }}
            >
              {loading ? "Logging in..." : "Enter Portal →"}
            </button>
          </form>

          <p style={{ color: "#333", fontSize: 12, marginTop: 20, textAlign: "center" }}>
            Don't have a Certificate ID?{" "}
            <span
              style={{ color: "var(--accent)", cursor: "pointer" }}
              onClick={() => navigate("/register-internship")}
            >
              Register here →
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}